function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';

/**
 * Custom hook to manage and sort prior runs data
 * @param {Object} priorRunsData - Object of prior runs keyed by timestamp
 * @returns {Array} Sorted array of prior runs (most recent first, max 3)
 */
const usePriorRuns = (priorRunsData = {}) => {
  const priorRunsArray = useMemo(() => {
    const priorRuns = priorRunsData || {};
    const arr = Object.entries(priorRuns).map(([id, run]) => _objectSpread({
      id
    }, run));
    // Sort by timestamp descending (most recent first)
    return arr.sort((a, b) => {
      var _a$summary, _b$summary;
      const timeA = new Date(((_a$summary = a.summary) === null || _a$summary === void 0 ? void 0 : _a$summary.timestamp) || a.id).getTime();
      const timeB = new Date(((_b$summary = b.summary) === null || _b$summary === void 0 ? void 0 : _b$summary.timestamp) || b.id).getTime();
      return timeB - timeA;
    }).slice(0, 3);
  }, [priorRunsData]);
  return priorRunsArray;
};
export default usePriorRuns;